import styled from "styled-components";

export const StarIconContainer = styled.div<{
  size: number;
  color: string;
  $filled: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;

  svg {
    width: 100%;
    height: 100%;
    color: ${({ color }) => color};
  }
`;
